<ng-template #modal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Pasajeros Asegurados</h4>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="btn-close" type="button"></button>
    </div>
    <div class="modal-body">
        <div ngbAccordion>
            @for ( passanger of passangers; track $index){
                <div ngbAccordionItem >
                    <h2 ngbAccordionHeader>
                        <button class="btn btn-light bg-light text-dark focus-ring focus-ring-dark" ngbAccordionButton>
                           <span class="mx-2">{{passanger.name}} {{passanger.lastName}}</span>
                           <small>ID de identidad {{passanger.id}}</small>
                        </button>
                    </h2>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template class="d-flex flex-column gap-1">
                                <div class="d-flex align-items-start border-bottom small py-2 flex-column gap-0">
                                    <span class="fw-semibold">Pasaporte</span>
                                    <span>{{passanger.passport || 'N/A'}}</span>
                                </div>
                                <div class="d-flex align-items-start border-bottom small py-2 flex-column gap-0">
                                    <span class="fw-semibold">Nacimiento</span>
                                    <span>{{passanger.birthdate | date: dateFormats.ddMMyyyy}}</span>
                                </div>
                                <div class="d-flex align-items-start border-bottom small py-2 flex-column gap-0">
                                    <span class="fw-semibold">Género</span>
                                    <span>{{passanger.gender}}</span>
                                </div>
                                <div class="d-flex align-items-start border-bottom small py-2 flex-column gap-0">
                                    <span class="fw-semibold">P Principal</span>
                                    <span>{{passanger.principal ? 'Sí' : 'No'}}</span>
                                </div>
                                <div class="d-flex align-items-start border-bottom small py-2 flex-column gap-0">
                                    <span class="fw-semibold">P Expuesta</span>
                                    <span>{{passanger.pepExposed ? 'Sí' : 'No'}}</span>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            }
        </div>

    </div>
    <div class="modal-footer">
      <button (click)="modal.dismiss('Cross click')" class="btn btn-outline-dark" type="button">Cerrar</button>
    </div>
</ng-template>
